import './chunk-6ea13200.js';
import './chunk-17222463.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { F as Field } from './chunk-f3c004c8.js';
export { F as BField } from './chunk-f3c004c8.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Field);
  }
};
use(Plugin);

export default Plugin;
